/*
 * @Author: your name
 * @Date: 2021-08-11 09:56:03
 * @LastEditTime: 2022-03-07 18:25:41
 * @LastEditors: Do not edit
 * @Description: In User Settings Edit
 * @FilePath: /ocr/src/store/interface.js
 */
import axios from 'axios'
import { message } from 'ant-design-vue'
import { lang } from '@/locales'
import { getItemFromCookie, removeCookieItem } from '../utils/url-tools'
import dotsConfig from '../config/url-config'

// let startTime = ''

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  // startTime = Date.now()
  const token = getItemFromCookie('dots-token') || localStorage.token
  config.headers.Authorization = token ? `Bearer ${token}` : ''
  config.headers.lang = localStorage.lang
  config.headers['Cache-Control'] = 'no-cache'
  if (/get/i.test(config.method)) { // 判断get请求
    config.params = config.params || {}
    config.params.t = Date.parse(new Date()) / 1000 // 添加时间戳
    //   config.params.lang = localStorage.lang // 添加语言
    // } else if (/post/i.test(config.method) && config.data) {
    //   config.data.lang = localStorage.lang // 添加语言
  }

  // console.log('config11', config)
  // console.log('before', startTime / 1000, Date.now() / 1000)
  // console.log(config);
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // console.log('after', (Date.now() - startTime) / 1000, Date.now() / 1000)
  if (response && response.headers && (response.headers.authorization)) {
    // console.log(response.headers)
    localStorage.token = response.headers.authorization.slice(7)
  }

  // 对响应数据做点什么
  if (response && response.data && response.data.code == 200) {
    return response
  }
  if (response && response.data && response.data.code == 403) {
    removeCookieItem('dots-token')
    localStorage.removeItem('token')
    const url = dotsConfig.dotsUrl ? dotsConfig.dotsUrl : process.env.VUE_APP_INTEGRATED_URL
    console.log('url', url)
    location.href = url + '/login'
  } else {
    message.error(response.data.message)
    // return {data:{code:'999'}}//模拟一个错误
  }
  return response
}, function (error) {
  // 对响应错误做点什么
  message.error(error.msg || lang('request_failed'))
  return Promise.reject(error)
})

export default axios
